export default __webpack_public_path__ + "static/media/terraform_cloud.437d16f2.svg";